// extracted by mini-css-extract-plugin
var _1 = "MyTradesListStyle-module__agreement____ezkM";
var _2 = "MyTradesListStyle-module__buy___RQ_E7";
var _3 = "MyTradesListStyle-module__company-logo___SeLvz";
var _4 = "MyTradesListStyle-module__company-logo___SeLvz";
var _5 = "MyTradesListStyle-module__currency___BWDCm";
var _6 = "MyTradesListStyle-module__icon-agreement-wrapper___TdSdH";
var _7 = "MyTradesListStyle-module__icon-container___qDUC7";
var _8 = "MyTradesListStyle-module__icon-agreement-wrapper___TdSdH";
var _9 = "MyTradesListStyle-module__icon-container___qDUC7";
var _a = "MyTradesListStyle-module__sell___y5Loq";
var _b = "MyTradesListStyle-module__share-name___olIqG";
var _c = "MyTradesListStyle-module__share-name___olIqG";
var _d = "MyTradesListStyle-module__shares-item___FxcXJ";
var _e = "MyTradesListStyle-module__shares-item___FxcXJ";
var _f = "MyTradesListStyle-module__table-container___EHowI";
var _10 = "MyTradesListStyle-module__table-container___EHowI";
var _11 = "MyTradesListStyle-module__trade-ammount___iHTsk";
var _12 = "MyTradesListStyle-module__trade-btn___jhQFM";
var _13 = "MyTradesListStyle-module__trade-date___tRO9y";
var _14 = "MyTradesListStyle-module__trade-fee___ALSDs";
var _15 = "MyTradesListStyle-module__trade-name___HTdaL";
var _16 = "MyTradesListStyle-module__trade-price___pCa80";
var _17 = "MyTradesListStyle-module__trade-status___ZFohV";
var _18 = "MyTradesListStyle-module__trade-total___f5rx9";
var _19 = "MyTradesListStyle-module__trade-type___H9D7J";
var _1a = "MyTradesListStyle-module__trade-ammount___iHTsk";
var _1b = "MyTradesListStyle-module__trade-btn___jhQFM";
var _1c = "MyTradesListStyle-module__trade-date___tRO9y";
var _1d = "MyTradesListStyle-module__trade-fee___ALSDs";
var _1e = "MyTradesListStyle-module__trade-name___HTdaL";
var _1f = "MyTradesListStyle-module__trade-price___pCa80";
var _20 = "MyTradesListStyle-module__trade-status___ZFohV";
var _21 = "MyTradesListStyle-module__trade-total___f5rx9";
var _22 = "MyTradesListStyle-module__trade-type___H9D7J";
var _23 = "MyTradesListStyle-module__trades-header___rCGDA";
var _24 = "MyTradesListStyle-module__trades-item___MMj96";
var _25 = "MyTradesListStyle-module__trades-row___iE1q0";
var _26 = "MyTradesListStyle-module__trades-table___DATSA";
var _27 = "MyTradesListStyle-module__trades-header___rCGDA";
var _28 = "MyTradesListStyle-module__trades-item___MMj96";
var _29 = "MyTradesListStyle-module__trades-row___iE1q0";
var _2a = "MyTradesListStyle-module__trades-table___DATSA";
export { _1 as "agreement", _2 as "buy", _3 as "company-logo", _4 as "companyLogo", _5 as "currency", _6 as "icon-agreement-wrapper", _7 as "icon-container", _8 as "iconAgreementWrapper", _9 as "iconContainer", _a as "sell", _b as "share-name", _c as "shareName", _d as "shares-item", _e as "sharesItem", _f as "table-container", _10 as "tableContainer", _11 as "trade-ammount", _12 as "trade-btn", _13 as "trade-date", _14 as "trade-fee", _15 as "trade-name", _16 as "trade-price", _17 as "trade-status", _18 as "trade-total", _19 as "trade-type", _1a as "tradeAmmount", _1b as "tradeBtn", _1c as "tradeDate", _1d as "tradeFee", _1e as "tradeName", _1f as "tradePrice", _20 as "tradeStatus", _21 as "tradeTotal", _22 as "tradeType", _23 as "trades-header", _24 as "trades-item", _25 as "trades-row", _26 as "trades-table", _27 as "tradesHeader", _28 as "tradesItem", _29 as "tradesRow", _2a as "tradesTable" }
